<template>
    <div class="accordion" id="accordionEscrituracion">
        <div class="accordion-item opcionDetalle">
            <h2 class="accordion-header" id="headingEscrituracion">
                <button
                    class="
                        accordion-button
                        collapsed
                        btn btn-primary
                        rounded-pill
                    "
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseEscrituracion"
                    aria-expanded="false"
                    aria-controls="collapseEscrituracion"
                >
                    Escrituración
                </button>
            </h2>
            <div
                id="collapseEscrituracion"
                class="accordion-collapse collapse"
                aria-labelledby="headingEscrituracion"
                data-bs-parent="#accordionEscrituracion"
            >
                <div class="accordion-body">
                       <div class="row">
                          <div class="col-md-12 col-lg-12">
                              <div
                                class="
                                    card card-body
                                    text-start
                                    mb-3
                                    cabeceraDetalle
                                "
                            >
                                <h5 class="card-title">
                                    Dictamen jurídico
                                </h5>
                                <hr />
                                <p id="dictamenJuridico">{{ $filters.StringFilter(operacion.dictamenJuridico) }}</p>
                            </div>
                          </div>
                        </div>
                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div
                                class="
                                    card card-body
                                    text-start
                                    mb-3
                                    cuerpoDetalleI
                                "
                            >
                                <h5 class="card-title">
                                    Vendedor de la propiedad
                                </h5>
                                <hr />
                                <p>Vendedor: {{ operacion.vendedor }}</p>
                                <p>
                                    Estado civil: {{ $filters.StringFilter(operacion.estadoCivilVendedor) }}
                                </p>
                                <p>
                                    Régimen matrimonial:
                                    {{ $filters.StringFilter(operacion.regimenMatromonialVendedor) }}
                                </p>
                                <p>Cónyuge: {{ $filters.CapitalizeFilter(operacion.conyugeVendedor) }}</p>
                                <p>
                                    Apoderado legal:
                                    {{ $filters.CapitalizeFilter(operacion.apoderadoLegalVendedor) }}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div
                                class="
                                    card card-body
                                    text-start
                                    mb-3
                                    cuerpoDetalleD
                                "
                            >
                                <h5 class="card-title">Garantía</h5>
                                <hr />
                                <p>Ubicación: {{ operacion.ubicacionInmueble }}</p>
                                <p>Colonia: {{ operacion.coloniaInmueble }}</p>
                                <p>Municipio: {{ $filters.CapitalizeFilter(operacion.ciudadInmueble) }}</p>
                                <p>Estado: {{ $filters.CapitalizeFilter(operacion.estadoInmueble) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 col-lg-6">
                            <div
                                class="
                                    card card-body
                                    text-start
                                    mb-3
                                    cuerpoDetalleI
                                "
                            >
                                <h5 class="card-title">Avalúo</h5>
                                <hr />
                                <p>Valuador: {{ operacion.valuador }}</p>
                                <p>Valor: {{ $filters.MoneyFilter(operacion.valorAvaluo) }}</p>
                                <p>Emisión: {{ $filters.DateFilter(operacion.fechaAvaluo) }}</p>
                                <p>
                                    Total m<sup>2</sup> : {{ operacion.totalM2 }}
                                </p>
                                <p>
                                    Valor m<sup>2</sup> : {{ $filters.MoneyFilter(operacion.valorM2) }}
                                </p>
                                <p>
                                    Valor del terreno: {{ $filters.MoneyFilter(operacion.valorTerreno) }}
                                </p>
                                <p>
                                    Valor de la construcción:
                                    {{ $filters.MoneyFilter(operacion.valorConstruccion) }}
                                </p>
                                <p>Vigencia: {{ $filters.DateFilter(operacion.vigenciaAvaluo) }}</p>
                                <p>Póliza: {{ operacion.poliza }}</p>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-6">
                            <div
                                class="
                                    card card-body
                                    text-start
                                    mb-3
                                    cuerpoDetalleD
                                "
                            >
                                <h5 class="card-title">
                                    Certificado libertad gravamen
                                </h5>
                                <hr />
                                <p>
                                    Emisión: {{ $filters.DateFilter(operacion.fechaEmisionGravamen) }}
                                </p>
                                <p>
                                    Vencimiento:
                                    {{ $filters.DateFilter(operacion.fechaVencimientoGravamen) }}
                                </p>
                                <p>
                                    Grávamenes: {{ operacion.descripcionGravamen }}
                                </p>
                                <p>Folio: {{ operacion.folioGravamen }}</p>
                            </div>
                            <div class="col-lg-12">
                                <div
                                    class="
                                        card card-body
                                        text-start
                                        mb-3
                                        cuerpoDetalleD
                                    "
                                >
                                    <h5 class="card-title">Notaría</h5>
                                    <hr />
                                    <p>Notaría: {{ operacion.notaria }}</p>
                                    <p>
                                    Nombre del notario: {{ $filters.CapitalizeFilter(operacion.notario) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'DetalleEscrituracion',

    props: {
        operacion: {}
    },

    methods: {
        formatearFecha(valor) {
            let lista = valor.split('T')
            return lista[0]
        }
    }
})
</script>

<style scoped>
    .texto,
    p,
    span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #302d74;
    }

    .btn {
        z-index: 10;
        font-weight: 600;
        font-size: 18px;
    }

    #dictamenJuridico {
        text-align: justify;
    }
</style>